import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7f479475")

_pushScopeId("data-v-7f479475")
const _hoisted_1 = { class: "user" }
const _hoisted_2 = { class: "user__name" }
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", { class: "separator" }, null, -1)
const _hoisted_4 = { class: "routes" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OAvatar = _resolveComponent("OAvatar")
  const _component_router_link = _resolveComponent("router-link")
  const _component_OSidebar = _resolveComponent("OSidebar")

  return (_openBlock(), _createBlock(_component_OSidebar, {
    visible: _ctx.visibleComputed,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.visibleComputed = $event))
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_OAvatar, {
          label: _ctx.userCapitalLetter,
          class: "user__avatar",
          size: "xlarge",
          shape: "circle"
        }, null, 8, ["label"]),
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.userName), 1),
        _createVNode("div", {
          class: "user__action",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSignout && _ctx.handleSignout(...args)))
        }, "SAIR")
      ]),
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.routes, (route) => {
          return (_openBlock(), _createBlock("div", {
            key: route.path
          }, [
            _createVNode(_component_router_link, {
              to: route.path,
              custom: ""
            }, {
              default: _withId(({ navigate, isActive }) => [
                _createVNode("div", {
                  class: ['route', { 'route--active': isActive }]
                }, [
                  _createVNode("span", {
                    class: "route__text",
                    onClick: ($event: any) => (!isActive && _ctx.handleRouteClick(navigate))
                  }, _toDisplayString(route.text), 9, ["onClick"])
                ], 2)
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
})